export function parseApiRecords(apiCall) {
    if (!apiCall?.status) {
        return [];
    }
    const data = apiCall.context?.message?.data;
    if (data?.records && Array.isArray(data.records)) {
        return data.records;
    }
    if (Array.isArray(data)) {
        return data;
    }
    return [];
}

export default parseApiRecords;
